// NPM Imports
import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SketchPicker } from "react-color";
import { debounce } from "lodash";
import { Tooltip } from "../../revvComponents";
import { checkStylesInSelection } from "../../utils/editorUtils";
import { checkSelectionHasEntity } from "../../utils/draftUtils";

// Internals imports
import { DOCUMENTS } from "../../constants";

// Destructuring
const { FONT_COLORS } = DOCUMENTS;
const COPY_FONT_COLORS = [...FONT_COLORS];
COPY_FONT_COLORS.unshift("transparent");
COPY_FONT_COLORS.pop();
export default class CustomTextHighlight extends Component {
  customColorListWrapperRef = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      colorSelected: "#ffffff",
    };
  }

  componentDidMount = () => {
    this.setState({
      colorSelected: this._getSelectedColor(),
    });
    if (this.props.activeToolbarDropDown) {
      this.props.toogleToolbarDropDown(null);
    }
    document.addEventListener("mousedown", this._handleClick, false);
  };

  componentDidUpdate = prevProps => {
    if (
      prevProps.editorState.getSelection().getFocusOffset() !==
        this.props.editorState.getSelection().getFocusOffset() &&
      !this.props.editorState.getSelection().isCollapsed()
    ) {
      const { editorState } = this.props;
      const checkCount = checkStylesInSelection(
        editorState,
        "FONTTEXTHIGHLIGHT",
      );
      if (checkCount > 1) {
        this.setState({
          colorSelected: "#ffffff",
        });
        return;
      }
    }
    if (
      prevProps.editorState.getSelection().getAnchorOffset() !==
        this.props.editorState.getSelection().getAnchorOffset() ||
      (prevProps.editorState.getSelection().getFocusOffset() !==
        prevProps.editorState.getSelection().getAnchorOffset() &&
        this.props.editorState.getSelection().getFocusOffset() ===
          this.props.editorState.getSelection().getAnchorOffset())
    ) {
      const { editorState } = this.props;
      const checkCount = checkStylesInSelection(
        editorState,
        "FONTTEXTHIGHLIGHT",
      );
      if (checkCount > 1) {
        this.setState({
          colorSelected: "#ffffff",
        });
        return;
      }
      const colorSelected = this._getSelectedColor();
      if (this.state.colorSelected !== colorSelected) {
        this.setState({
          colorSelected,
        });
      }
    }
  };

  componentWillUnmount = () => {
    document.removeEventListener("mousedown", this._handleClick, false);
  };

  _colorOnChangeDebounce = debounce(
    color => {
      if (color.hex === "transparent") {
        this.props.textHighlightUpdate(
          "FONTTEXTHIGHLIGHT",
          `FONTTEXTHIGHLIGHT_${color.hex}`,
        );
      } else
        this.props.textHighlightUpdate(
          "FONTTEXTHIGHLIGHT",
          `FONTTEXTHIGHLIGHT_${color.hex.substring(1, 7)}`,
        );
    },
    500,
    { leading: true, trailing: false },
  );

  _getSelectedColor = () => {
    const styles = Array.from(
      this.props.editorState.getCurrentInlineStyle(
        this.props.editorState.getSelection().getAnchorOffset(),
      ),
    );

    let getFontColor = null;
    if (styles && styles.length > 0) {
      getFontColor = styles.find(style => style.includes("FONTTEXTHIGHLIGHT_"));
    }
    let currentAppliedColor = null;
    if (getFontColor) {
      // eslint-disable-next-line prefer-destructuring
      currentAppliedColor = `#${getFontColor.split("_")[1]}`;
    } else {
      const { editorState, metaData } = this.props;

      if (
        metaData &&
        metaData.FONTTEXTHIGHLIGHT &&
        editorState.getSelection().isCollapsed() &&
        editorState.getSelection().getFocusOffset() === 0
      ) {
        currentAppliedColor = `#${metaData.FONTTEXTHIGHLIGHT.split("_")[1]}`;
      }
    }
    if (!getFontColor && !currentAppliedColor) {
      if (checkSelectionHasEntity(this.props.editorState, "LINK")) {
        currentAppliedColor = "#3d50e0";
      }
    }
    return currentAppliedColor || "#ffffff";
  };

  _handleClick = e => {
    if (
      !this.node.contains(e.target) &&
      this.props.activeToolbarDropDown === "TEXT_HIGHLIGHT"
    ) {
      this.props.toogleToolbarDropDown(null);
      this.props.handleCustomColorDropDownOpen(
        false,
        this.props.activeToolbarDropDown === "TEXT_HIGHLIGHT",
      );
    }

    if (
      this.node.contains(e.target) &&
      this.props.activeToolbarDropDown === "TEXT_HIGHLIGHT"
    ) {
      // prevent loosing editor focus when color is selected
      e.preventDefault();
    }
  };

  _onChange = (color, event) => {
    if (event && event.persist) {
      event.persist();
      event.preventDefault();
    }
    this.setState({
      colorSelected: color.hex,
    });

    this._colorOnChangeDebounce(color);
  };

  _toggleCustomColorDropdown = event => {
    event.preventDefault();
    this.props.toogleToolbarDropDown(
      this.props.activeToolbarDropDown === "TEXT_HIGHLIGHT"
        ? null
        : "TEXT_HIGHLIGHT",
    );
    this.props.handleCustomColorDropDownOpen(
      true,
      this.props.activeToolbarDropDown === "TEXT_HIGHLIGHT",
    );
  };

  render() {
    return (
      <div
        className="draft-edit-items custom-style-wrapper "
        ref={ele => {
          this.node = ele;
        }}>
        <Tooltip
          placement="top"
          overlay="Text Highlight"
          align={{
            offset: [3, 0],
          }}>
          <button
            className={`text-color-btn toolbar-custom-inline-button toolbar-btn ${
              this.props.activeToolbarDropDown === "TEXT_HIGHLIGHT"
                ? "active"
                : ""
            }`}
            type="button"
            onMouseDown={this._toggleCustomColorDropdown}
            data-test="custom-color-text-color-btn">
            <span className="text-highlighter-icon">
              <FontAwesomeIcon icon={["fas", "highlighter"]} />
            </span>
            <div
              className="custom-highlight-bottom"
              style={{ background: this.state.colorSelected }}
            />
          </button>
        </Tooltip>
        {this.props.activeToolbarDropDown === "TEXT_HIGHLIGHT" ? (
          <div
            className="customcolor-dropdown-wrapper"
            ref={this.props.toolbarCustomColorDropdownRef}>
            <SketchPicker
              color={this.state.colorSelected}
              onChange={this._onChange}
              presetColors={COPY_FONT_COLORS}
              width={225}
              disableAlpha
              data-test="color-option-picker"
            />
          </div>
        ) : null}
      </div>
    );
  }
}
